import { tracked } from "@glimmer/tracking";
import Controller from "@ember/controller";
import { action } from "@ember/object";
import { service } from "@ember/service";
import { addUniqueValuesToArray } from "discourse/lib/array-tools";
import CustomReaction from "../../models/discourse-reactions-custom-reaction";

export default class UserActivityReactions extends Controller {
  @service siteSettings;

  @tracked canLoadMore = true;
  @tracked loading = false;
  @tracked beforeLikeId = null;
  @tracked beforeReactionUserId = null;

  #getLastIdFrom(array) {
    return array.length ? array[array.length - 1].reaction_user_id : null;
  }

  #updateBeforeIds(reactionUsers) {
    if (this.includeLikes) {
      const mainReaction =
        this.siteSettings.discourse_reactions_reaction_for_like;
      const [likes, reactions] = reactionUsers.reduce(
        (memo, elem) => {
          if (elem.reaction.reaction_value === mainReaction) {
            memo[0].push(elem);
          } else {
            memo[1].push(elem);
          }

          return memo;
        },
        [[], []]
      );

      this.beforeLikeId = this.#getLastIdFrom(likes);
      this.beforeReactionUserId = this.#getLastIdFrom(reactions);
    } else {
      this.beforeReactionUserId = this.#getLastIdFrom(reactionUsers);
    }
  }

  @action
  async loadMore() {
    if (!this.canLoadMore || this.loading) {
      return [];
    }

    this.loading = true;
    const reactionUsers = this.model;

    try {
      if (!this.beforeReactionUserId) {
        this.#updateBeforeIds(reactionUsers);
      }

      const opts = {
        actingUsername: this.actingUsername,
        includeLikes: this.includeLikes,
        beforeLikeId: this.beforeLikeId,
        beforeReactionUserId: this.beforeReactionUserId,
      };

      const newReactionUsers = await CustomReaction.findReactions(
        this.reactionsUrl,
        this.username,
        opts
      );

      const flattened = newReactionUsers.map((r) =>
        CustomReaction.flattenForPostList(r)
      );

      addUniqueValuesToArray(reactionUsers, flattened);
      this.#updateBeforeIds(flattened);

      if (flattened.length === 0) {
        this.canLoadMore = false;
      }

      return flattened;
    } finally {
      this.loading = false;
    }
  }
}
